(() => {
  const pathname = location.pathname.replace(/\/$/, '');
  const isAccount = /\/account$/.test(pathname);
  const isOrder = pathname.endsWith('/pages/ws-quick-order-form');
  const isLanding = pathname.endsWith('/pages/wholesale');
  const isWholesalePage = /\/pages\/(ws-cart|ws-proxy|ws-quick-order-form|wholesale-registration-form|ws-account-create)$/.test(pathname);
  function carousel(root) {
    const track = root.querySelector('.bbw-seller-track');
    if (!track) return;
    const control = root.querySelector('[data-bbw-pause]');
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    let paused = motion.matches;
    let visible = false;
    let interacting = false;
    const sync = () => {
      control.textContent = paused ? '▶' : 'Ⅱ';
      control.setAttribute('aria-label', paused ? root.dataset.resume : root.dataset.pause);
      control.setAttribute('aria-pressed', String(paused));
    };
    const step = direction => {
      const end = track.scrollWidth - track.clientWidth;
      const atEnd = track.scrollLeft >= end - 5;
      const atStart = track.scrollLeft < 5;
      const left = direction > 0 && atEnd ? 0 : direction < 0 && atStart ? end : track.scrollLeft + direction * track.clientWidth;
      track.scrollTo({left, behavior: motion.matches ? 'instant' : 'smooth'});
    };
    root.querySelectorAll('[data-bbw-step]').forEach(button => button.addEventListener('click', () => step(Number(button.dataset.bbwStep))));
    control.addEventListener('click', () => { paused = !paused; sync(); });
    root.addEventListener('mouseenter', () => interacting = true);
    root.addEventListener('mouseleave', () => interacting = false);
    root.addEventListener('focusin', () => interacting = true);
    root.addEventListener('focusout', () => interacting = false);
    track.addEventListener('keydown', event => {
      if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault(); step(event.key === 'ArrowRight' ? 1 : -1);
    });
    motion.addEventListener('change', () => { if (motion.matches) { paused = true; sync(); } });
    const observer = new IntersectionObserver(entries => visible = entries[0].isIntersecting, {threshold: .5});
    observer.observe(track);
    const timer = setInterval(() => {
      if (!root.isConnected) { clearInterval(timer); observer.disconnect(); return; }
      if (visible && !paused && !interacting && !document.hidden) step(1);
    }, 5000);
    sync();
  }
  function wholesaleControls() {
    if (!window.isWsgCustomer) return;
    document.body.classList.add('bbw-approved');
    document.querySelectorAll('[data-bbw-quantity]').forEach(control => { control.hidden = false; });
    document.querySelectorAll('a[href]').forEach(link => {
      const url = new URL(link.getAttribute('href'), location.href);
      if (url.hostname.replace(/^www\./, '') === location.hostname.replace(/^www\./, '') && url.pathname === '/' && !url.hash) link.setAttribute('href', '/account');
    });
    const template = document.getElementById('bb-stockist-experience-template');
    const categories = template ? JSON.parse(template.dataset.bbwCategories || '{}') : {};
    const patterns = [['399328149747',/all products|shop all/i],['450739241203',/snack/i],['415489294579',/back up|accessor/i],['417537425651',/240/],['414552064243',/120/],['414551834867',/350/]];
    document.querySelectorAll('#wsg-quick-order-form .spof-nav .wsg-nav-link').forEach(link => {
      if (link.dataset.bbwCompact) return;
      const original = link.textContent.trim();
      const match = patterns.find(([id, pattern]) => (link.getAttribute('href') || '').includes(id) || pattern.test(original));
      if (!match || !categories[match[0]]) return;
      link.dataset.bbwCompact = 'true'; link.title = original; link.setAttribute('aria-label', original); link.textContent = categories[match[0]];
    });
    document.querySelectorAll('#wsg-quick-order-form .spof-content .item').forEach(group => {
      if (!group.querySelector('.wsg-variant-row')) return;
      group.classList.add('bbw-variant-group');
      if (group.querySelector('.bbw-bundle-label')) return;
      const bundle = group.textContent.match(/(?:120|240|350)\s*ml\s+Back Up Bundles/i);
      if (!bundle) return;
      const heading = document.createElement('h3'); heading.className = 'bbw-bundle-label'; heading.textContent = bundle[0]; group.prepend(heading);
    });
  }
  document.addEventListener('click', event => {
    if (!window.isWsgCustomer) return;
    const link = event.target.closest('a[href]');
    if (!link) return;
    const url = new URL(link.getAttribute('href'), location.href);
    if (url.hostname.replace(/^www\./, '') === location.hostname.replace(/^www\./, '') && url.pathname === '/' && !url.hash) link.setAttribute('href', '/account');
  }, true);
  function mount() {
    const approved = Boolean(window.isWsgCustomer);
    if (approved && pathname === '') { location.replace('/account' + location.search); return; }
    if (!document.body.classList.contains('bbw-approved')) wholesaleControls();
    if (approved || isWholesalePage || isLanding) document.querySelectorAll('.m-announcement-bar__content').forEach(bar => { if (bar.textContent !== 'BBCINO WHOLESALE ACCOUNT') bar.textContent = 'BBCINO WHOLESALE ACCOUNT'; });
    if (isWholesalePage || isAccount && approved || isLanding) document.body.classList.add('bbw-stockist-page');
    if (isOrder) document.body.classList.add('bbw-order-page');
    if (isAccount && !approved || !isAccount && !isOrder && !isLanding) return;
    let root = document.getElementById('bb-stockist-experience');
    if (!root) {
      const template = document.getElementById('bb-stockist-experience-template');
      const main = document.getElementById('MainContent');
      if (!template || !main) return;
      const fragment = template.content.cloneNode(true);
      root = fragment.querySelector('.bbw');
      if (isLanding) main.replaceChildren(fragment); else main.prepend(fragment);
      root.querySelectorAll('[data-bbw-sellers]').forEach(carousel);
    }
    root.querySelectorAll('[data-bbw-resources],[data-bbw-hello],[data-bbw-wholesale-note]').forEach(element => element.hidden = !approved);
    if (isAccount && !root.dataset.bbwAccountReady) {
      root.dataset.bbwAccountReady='true';
      document.body.classList.add('bbw-stockist-account');
      const nav = document.querySelector('.m-account__navigation');
      if (nav && !nav.querySelector('.bbw-account-quick')) {
        const quick = document.createElement('a');
        quick.className = 'bbw-account-quick'; quick.href = '/pages/ws-quick-order-form';
        quick.textContent = 'Quick Order'; nav.appendChild(quick);
      }
      document.querySelectorAll('#MainContent p,#MainContent div,#MainContent span').forEach(element => {
        if (element.closest('#bb-stockist-experience,.m-customer-order,.m-customer-info') || element.querySelector('table,form,input,button,.m-customer-order,.m-account__navigation')) return;
        const text = element.textContent.trim();
        if (/^(Little cups\. Big shelf appeal\.|Ready to restock\?|No minimum order|Australian shipping capped|Need product photos|Stockist resources:)/i.test(text) && !/Order History|Account details/i.test(text)) element.classList.add('bbw-legacy-copy');
      });
      document.querySelectorAll('#MainContent a[href*="/pages/ws-quick-order-form"]').forEach(link => {
        if (!link.closest('#bb-stockist-experience,.m-account__navigation')) link.classList.add('bbw-legacy-copy');
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount, {once:true}); else mount();
  document.addEventListener('wsg:data-ready', mount);
  {
    let mountQueued = false;
    const accountObserver = new MutationObserver(records => {
      if (mountQueued || !records.some(record => record.addedNodes.length)) return;
      mountQueued = true;
      requestAnimationFrame(() => { mountQueued = false; mount(); });
    });
    const watchAccount = () => {
      const main = document.getElementById('MainContent');
      if (main) accountObserver.observe(main, {childList:true, subtree:true});
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchAccount, {once:true}); else watchAccount();
  }
  let attempts = 0;
  const readiness = setInterval(() => { mount(); if (window.isWsgCustomer || ++attempts >= 30) clearInterval(readiness); }, 500);
})();

(() => {
  const orderPath = '/pages/ws-quick-order-form';
  const toolkit = 'https://www.dropbox.com/scl/fo/toe3oxw5e05mlepcvhhbh/ADzERO-zB_9_txkGYu7Q77Y?rlkey=h2my2y6pj7mp9jaawvf0tkcyb&dl=0';
  // Delegate pricing, quantities, pagination and cart writes to Wholesale Gorilla.
  // Only supply the initial category when no category was requested.
  const nativeAppend = window.appendContent;
  const rangeParams=new URLSearchParams(location.search);
  if(location.pathname===orderPath) window.wsgSpofPaginationLimit=20;
  if (typeof nativeAppend === 'function') window.appendContent = function(method, url, target) {
    if (target === 'wsg-quick-order-form') {
      const destination = new URL(url, location.origin);
      if (!destination.searchParams.get('id') || destination.searchParams.get('id') === '0') {
        destination.searchParams.set('id', '414552064243');
        window.wsgCollectionId = '414552064243';
      }
      const handles={'414552064243':'bbcino-cups-120ml-1','417537425651':'bambinocino-cups-240ml','513442218227':'wholesale-350ml-cups-and-accessories','450739241203':'snack-all','451192357107':'shop-all-cups','415489294579':'straws-and-cleaners'};
      const handle=handles[destination.searchParams.get('id')];
      if(handle){destination.searchParams.set('handle',handle);window.wsgCollectionHandle=handle;}
      return nativeAppend(method, destination.pathname + destination.search, target);
    }
    return nativeAppend(method, url, target);
  };
  const qa=[
    ['Is there a minimum order?','No minimum order. Choose the quantities and mix of designs that work for your store.'],
    ['What is the wholesale price?','Approved Australian stockists receive 50% off RRP, excluding GST. Wholesale prices shown exclude GST; review GST and the final total at checkout.'],
    ['How much is Australian shipping?','Australian wholesale shipping is capped at $25, with free shipping on orders over $450. Check your final shipping amount before payment.'],
    ['When will my order leave?','Orders usually dispatch the same or next business day from Perth. Dispatch time is separate from the delivery time shown by the carrier.'],
    ['How do I place or change an order?','Use Quick order to choose products and quantities. Quantity changes save to your cart automatically. Review your cart, add a purchase order number or note if needed, and continue to checkout. Your order is only placed after checkout.'],
    ['How do payment and billing addresses work?','Review the payment options available at checkout. You can enter or change your billing address during checkout. Any payment terms agreed with El apply to your account.'],
    ['Where do I edit my details or reorder?','Open My account to view order history and manage saved addresses. For a change to your account name or email, contact El at bbcinocup@gmail.com. Use Quick order whenever you are ready to restock.'],
    ['Where are photos, barcodes and product information?','Open Wholesale toolkit for product photos, descriptions, barcodes, logos and social content, ready to use.'],
    ['What if something arrives damaged or incorrect?','Email bbcinocup@gmail.com with your order number, details and photos where relevant so El can help. For international shipping or any other questions, email El before ordering.']
  ];
  function element(tag,cls,text){const el=document.createElement(tag);if(cls)el.className=cls;if(text)el.textContent=text;return el;}
  const orderPages = [
    ['414552064243', '120ml Babycino cups'],
    ['417537425651', '240ml BambinoCino cups'],
    ['513442218227', '350ml cups + accessories'],
    ['450739241203', 'Snack pots']
  ];
  function groupedOrder(){
    const form=document.querySelector('#spof-update-cart');
    const table=form?.querySelector('.wsg-col-panel .wsg-table');
    const menu=document.querySelector('#wsg-quick-order-form .spof-nav .nav-menu');
    if(!table || !menu || table.dataset.bbwPaged) return;
    table.dataset.bbwPaged='true';
    const params=new URLSearchParams(location.search);
    const requested=params.get('id') || orderPages[0][0];
    const searching=Boolean(params.get('search'));
    const range=params.get('range') || ({'451192357107':'cups','415489294579':'extras'}[requested] || 'all');
    const current=Math.max(0,orderPages.findIndex(([id])=>id===requested));
    const handles=['bbcino-cups-120ml-1','bambinocino-cups-240ml','wholesale-350ml-cups-and-accessories','snack-all'];
    const categoryData=[['Shop All','all',orderPages[0][0],handles[0]],['Babycino Cups','cups','451192357107','shop-all-cups'],['Snack Pots','snacks','450739241203','snack-all'],['Back Up Bundles and Accessories','extras','415489294579','straws-and-cleaners']];
    const counts=window.bbwOrderCounts || [29,20,20,20];
    const steps=orderPages.flatMap((_,index)=>Array.from({length:Math.max(1,Math.ceil(counts[index]/20))},(_,page)=>({index,page:page+1})));
    const activeStep=Math.max(0,steps.findIndex(step=>step.index===current&&step.page===Number(params.get('page')||1)));
    const pageLink=(stepIndex,label)=>{
      const {index,page}=steps[stepIndex];
      const a=element('a','bbw-order-tab',label || String(stepIndex+1));
      a.href=orderPath+'?range=all&id='+orderPages[index][0]+'&handle='+handles[index]+'&page='+page;
      if(stepIndex===activeStep)a.setAttribute('aria-current','page');
      a.setAttribute('aria-label',label || 'Page '+(stepIndex+1)+': '+orderPages[index][1]);
      return a;
    };
    menu.style.setProperty('display','none','important');
    menu.setAttribute('aria-hidden','true');
    let categoryNav=document.querySelector('.bbw-category-nav');
    if(!categoryNav){categoryNav=element('div','bbw-category-nav');menu.before(categoryNav);}
    categoryNav.replaceChildren(...categoryData.map(([label,key,id,handle])=>{
      const a=element('a','bbw-order-tab',label);a.href=orderPath+'?range='+key+'&id='+id+'&handle='+handle;
      if(!searching&&key===range)a.setAttribute('aria-current','page');return a;
    }));
    menu.parentElement.removeAttribute('role');
    menu.parentElement.removeAttribute('tabindex');
    const title=document.querySelector('.wsg-collection-title');
    if(title)title.textContent=searching?'Search results':range==='all'?'Shop All':(categoryData.find(c=>c[1]===range)?.[0] || 'Shop All');
    const allPages=range==='all'&&!searching;
    document.body.classList.toggle('bbw-all-pages',allPages);
    document.querySelectorAll('.bbw-page-steps').forEach(nav=>nav.remove());
    if(allPages){
      const bottom=element('nav','bbw-page-steps');bottom.setAttribute('aria-label','Shop all product pages');
      if(activeStep>0)bottom.append(pageLink(activeStep-1,'‹'));
      else {const span=element('span','bbw-page-disabled','‹');span.setAttribute('aria-hidden','true');bottom.append(span);}
      steps.forEach((_,i)=>bottom.append(pageLink(i)));
      if(activeStep<steps.length-1)bottom.append(pageLink(activeStep+1,'›'));
      else {const span=element('span','bbw-page-disabled','›');span.setAttribute('aria-hidden','true');bottom.append(span);}
      form.after(bottom);
    }
    const products=Array.from(table.querySelectorAll('[data-prod-id]')).filter(e=>!e.parentElement.closest('[data-prod-id]'));
    if(range==='all' && current<2 && products.length)table.prepend(element('h3','bbw-product-heading',orderPages[current][1]));
    if(range==='cups'){
      ['120ml Babycino cups','240ml BambinoCino cups','350ml BiggieCino cups'].forEach(label=>{
        const size=label.slice(0,3);const rows=products.filter(row=>(row.querySelector('.wsg-variant-title,.wsg-product-title')?.textContent||row.textContent).includes(size+'ml'));
        if(rows.length){table.append(element('h3','bbw-product-heading',label));rows.forEach(row=>table.append(row));}
      });
    }
    if((range==='all' && current===2) || requested==='450739241203'){
      const buckets=[[],[]];
      products.forEach(product=>{
        const title=(product.querySelector('.wsg-product-title,.wsg-variant-title')?.textContent || product.querySelector('a')?.textContent || '').trim();
        const silicone=(document.querySelector('.wsg-collections-list-'+product.getAttribute('data-prod-id'))?.textContent || '').includes('snack-silicone');
        const second=requested==='513442218227'?/back.?up|bundle|straw|cleaner|accessor|lid|band/i.test(title):silicone;
        buckets[Number(second)].push(product);
      });
      const labels=requested==='513442218227'?['350ml BiggieCino cups','Back up bundles and accessories']:['Bamboo snack pots','Silicone snack pots'];
      buckets.forEach((items,i)=>{if(!items.length)return;table.append(element('h3','bbw-product-heading',labels[i]));items.forEach(item=>table.append(item));});
    }
    table.querySelectorAll('img').forEach((img,i)=>{if(i>3){img.loading='lazy';img.decoding='async';}});
  }
  function polish(){
    const approved=Boolean(window.isWsgCustomer);
        const wholesale=approved||['/pages/ws-cart','/pages/ws-quick-order-form','/pages/ws-proxy','/pages/wholesale'].includes(location.pathname);
    if(!wholesale)return;
    if(wholesale&&!document.querySelector('.bbw-header-shortcut')){
      const header=document.querySelector('m-header,header,.m-header');
      if(header){const wrap=element('div','bbw-header-shortcut');const link=element('a','','Quick Order');link.href=orderPath;wrap.append(link);(header.querySelector('.m-header__wrapper')||header).append(wrap);}
    }
    document.querySelectorAll('.bbw-nav').forEach(nav=>{if(nav.dataset.bbwFinal)return;nav.dataset.bbwFinal='true';nav.replaceChildren();[['My Account','/account#account-details'],['Wholesale Toolkit',toolkit],['FAQ','#wholesale-faq']].forEach(([label,url])=>{const link=element('a','',label);link.href=url;if(url===toolkit){link.target='_blank';link.rel='noopener';}nav.append(link);});});
    const root=document.querySelector('#bb-stockist-experience');
    if(root&&!root.dataset.bbwFinal){
      root.dataset.bbwFinal='true';const title=root.querySelector('#bbw-toolkit-title');const eyebrow=root.querySelector('.bbw-resources .bbw-eyebrow');
      if(title&&eyebrow){title.textContent='Your stockist toolkit';eyebrow.textContent='We’ve got your shelf.';title.before(eyebrow);eyebrow.before(title);}
      if(!document.getElementById('wholesale-faq')){const faq=element('dialog','bbw-faq-dialog');faq.id='wholesale-faq';const close=element('button','bbw-faq-close','Close');close.type='button';close.addEventListener('click',()=>faq.close());faq.append(close,element('h2','','Wholesale FAQs'));qa.forEach(([question,answer])=>{const details=element('details');details.append(element('summary','',question),element('p','',answer));faq.append(details);});document.body.append(faq);}
    }
    const account=document.querySelector('.m-account');
    if(account&&approved&&!document.querySelector('#account-details')){
      const panel=element('section','bbw-account-tools');panel.id='account-details';panel.append(element('h2','','My Account'),element('p','','Manage your saved addresses and view your orders below.'));
      const address=element('a','','Edit Addresses');address.href='/account/addresses';const contact=element('a','','Update Name or Email');contact.href='mailto:bbcinocup@gmail.com?subject=Update%20my%20wholesale%20account%20details';panel.append(address,contact);account.prepend(panel);
    }
        document.querySelectorAll('#wsg-cart label,#wsg-cart h2,#wsg-cart h3,#wsg-cart button,#wsg-cart summary').forEach(e=>{const text=e.textContent.trim();if((/^(\+\s*)?add (a )?note/i.test(text)||/^(purchase order|p\.?o\.?)(\s|$)/i.test(text))&&text.length<100)e.classList.add('bbw-note-label');if(/^(shipping|billing) address$/i.test(text))e.classList.add('bbw-address-title');});
    groupedOrder();
    if(location.hash){const target=document.getElementById(location.hash.slice(1));if(target&&!target.dataset.bbwScrolled){target.dataset.bbwScrolled='true';requestAnimationFrame(()=>target.scrollIntoView());}}
  }
  let pending=false;
  const observer=new MutationObserver(records=>{if(pending||!records.some(r=>r.addedNodes.length && !r.target.closest?.('#bb-stockist-experience,.bbw-page-steps')))return;pending=true;requestAnimationFrame(()=>{pending=false;polish();});});
  function start(){polish();observer.observe(document.body,{childList:true,subtree:true});}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('wsg:data-ready',polish);window.addEventListener('hashchange',()=>{document.querySelectorAll('[data-bbw-scrolled]').forEach(e=>delete e.dataset.bbwScrolled);polish();});
})();

(() => {
  if(location.pathname!=='/pages/ws-cart')return;
  function tidy(){
    document.querySelectorAll('#wsg-cart .spof-btn,#wsg-cart [data-translation-selector="spofLinkButton"]').forEach(e=>{e.removeAttribute('data-translation-selector');if(e.textContent.trim()!=='Back To Quick Order')e.textContent='Back To Quick Order';});
    const clear=document.querySelector('#wsg-clear-cart');if(clear&&clear.textContent.trim()!=='Clear Cart')clear.textContent='Clear Cart';
    const next=document.querySelector('#wsg-checkout-two');if(next&&next.textContent.trim()!=='Continue To Checkout')next.textContent='Continue To Checkout';
    document.querySelectorAll('#wsg-cart .wsg-subtotal-discount-block').forEach(e=>{if(e.textContent.includes('Dynamic amount off'))e.hidden=true;});
  }
  new MutationObserver(tidy).observe(document.body,{childList:true,subtree:true});tidy();
})();
(() => {
  const toolkit='https://www.dropbox.com/scl/fo/toe3oxw5e05mlepcvhhbh/ADzERO-zB_9_txkGYu7Q77Y?rlkey=h2my2y6pj7mp9jaawvf0tkcyb&dl=0';
  const links=[['My Account','/account#account-details'],['Wholesale Toolkit',toolkit],['FAQ','#wholesale-faq'],['Email El','mailto:bbcinocup@gmail.com'],['Shop All','/collections/frontpage']];
  const makeLink=(label,url,cls)=>{const a=document.createElement('a');a.textContent=label;a.href=url;if(cls)a.className=cls;if(url===toolkit){a.target='_blank';a.rel='noopener';}return a;};
  function finish(){
    const wholesale=Boolean(window.isWsgCustomer)||document.body.classList.contains('bbw-stockist-page');
    if(!wholesale)return;
    document.body.classList.add('bbw-final-layout');
    document.querySelectorAll('.m-header__mobile-right,.m-header__right').forEach(group=>{
      const search=group.querySelector('m-search-popup');
      if(!search||group.querySelector('.bbw-header-quick'))return;
      search.before(makeLink('Quick Order','/pages/ws-quick-order-form','bbw-header-quick'));
      const email=makeLink('','mailto:bbcinocup@gmail.com','bbw-header-email');
      email.setAttribute('aria-label','Email El');
      email.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m4 7 8 6 8-6"/></svg>';
      search.after(email);
    });
    document.querySelectorAll('.m-menu-drawer__navigation,.m-header__desktop .m-menu').forEach(menu=>{
      if(menu.dataset.bbwFinalMenu)return;
      menu.dataset.bbwFinalMenu='true';
      const mobile=menu.classList.contains('m-menu-drawer__navigation');
      menu.replaceChildren(...links.map(([label,url])=>{const li=document.createElement('li');li.className=mobile?'m-menu-mobile__item':'m-menu__item';li.append(makeLink(label,url,mobile?'m-menu-mobile__link':'m-menu__link'));return li;}));
    });
    const welcome=document.querySelector('[data-bbw-welcome]');
    if(welcome){
      document.querySelectorAll('.bbw-logo-welcome').forEach(line=>line.remove());
      document.querySelectorAll('.bbw-nav').forEach(nav=>{
        if(nav.querySelector('.bbw-account-welcome'))return;
        const line=document.createElement('span');line.className='bbw-account-welcome';line.textContent=welcome.textContent.trim().replace(/\s+/g,' ');nav.append(line);
      });
    }
    document.querySelectorAll('.bbw-restock .bbw-section>a,.bbw-sellers .bbw-section>a,.bbw-benefits>a,.bbw-account-quick').forEach(a=>{
      if(a.textContent!=='Quick Order')a.textContent='Quick Order';
      if(a.getAttribute('href')!=='/pages/ws-quick-order-form')a.setAttribute('href','/pages/ws-quick-order-form');
    });
    document.querySelectorAll('.wsg-nav-link').forEach(a=>{if(a.textContent.includes('&amp;'))a.textContent=a.textContent.replaceAll('&amp;','&');});
  }
  document.addEventListener('click',event=>{
    const a=event.target.closest('a[href="#wholesale-faq"]');if(!a)return;
    const dialog=document.getElementById('wholesale-faq');if(!dialog)return;
    event.preventDefault();if(!dialog.open)dialog.showModal();
  });
  let queued=false;const observer=new MutationObserver(records=>{
    if(queued||!records.some(r=>r.addedNodes.length))return;
    queued=true;requestAnimationFrame(()=>{queued=false;finish();});
  });
  const start=()=>{finish();observer.observe(document.body,{childList:true,subtree:true});};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('wsg:data-ready',finish);
})();




